import { render, staticRenderFns } from "./HeaderControlsSocial.vue?vue&type=template&id=606b6e66&scoped=true&"
import script from "./HeaderControlsSocial.vue?vue&type=script&lang=js&"
export * from "./HeaderControlsSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606b6e66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('606b6e66')) {
      api.createRecord('606b6e66', component.options)
    } else {
      api.reload('606b6e66', component.options)
    }
    module.hot.accept("./HeaderControlsSocial.vue?vue&type=template&id=606b6e66&scoped=true&", function () {
      api.rerender('606b6e66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/HeaderControlsSocial.vue"
export default component.exports